<template>
  <div v-if="customer">
    <h3>
      {{ customer.name
      }}<span v-if="isDeleted" class="badge badge-danger ml-3">GELÖSCHT</span>
    </h3>
    <div class="d-flex">
      <div class="flex-grow-1"></div>
      <div v-if="!isDeleted">
        <v-button
          v-if="isAdmin"
          @click.native="deleteProfile"
          :working="deleting"
          class="btn-danger"
          >Löschen</v-button
        >
      </div>
    </div>
    <div v-if="calculatesZipcodeCache" class="alert alert-info">
      Hinweis: Da der Cache für dynamische PLZ berechnet wird, wird die
      Einstellung `dynamisch` erst später angewendet. Die Fakes behalten für
      diese Zeit den alten Wohnort.
    </div>
    <section>
      <MediaEditCard
        v-if="!isDeleted"
        :profile="customer"
        title="Fakes Media"
      ></MediaEditCard>

      <div class="row">
        <div class="col-4">
          <div class="card">
            <div class="card-header">Stammdaten</div>
            <div class="card-body">
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Erstellt am</label>
                <div class="col-12 col-md-8">
                  {{ created_at }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Angelegt von</label>
                <div class="col-12 col-md-8">
                  {{ customer.user.name }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Letzte Nachricht</label>
                <div class="col-12 col-md-8" v-html="customerLastMessage"></div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">In/Out Heute</label>
                <div class="col-12 col-md-8">
                  {{ history.today_in }} / {{ history.today_out }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label"
                  >In/Out dieser Monat</label
                >
                <div class="col-12 col-md-8">
                  {{ history.last_month_in }} / {{ history.last_month_out }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label"
                  >In/Out letzter Monat</label
                >
                <div class="col-12 col-md-8">
                  {{ history.this_month_in }} / {{ history.this_month_out }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">In/Out insgesamt</label>
                <div class="col-12 col-md-8">
                  {{ history.total_in }} / {{ history.total_out }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8" v-if="!isDeleted">
          <resource
            title="Ändern"
            :key="!allowMark"
            resource="customerProfile"
            resourceName="Fake"
            :original="customer"
            :attributes="[
              {
                name: 'sex',
                label: 'Geschlecht',
                type: 'SexSelector'
              },
              {
                name: 'name',
                label: 'Name',
                checkChanged: true
              },
              {
                name: 'country_iso3166',
                label: 'Land',
                type: 'OptionSelector',
                hideable: true,
                hideEvent: 'has-dynamic-zipcode'
              },
              {
                name: 'zipcode',
                label: 'PLZ',
                col: 3,
                hideable: true,
                hideEvent: 'has-dynamic-zipcode'
              },
              {
                name: 'has_dynamic_zipcode',
                label: 'Dynamische PLZ',
                type: 'CheckboxSelector',
                cantDisable: true
              },
              {
                name: 'mark',
                label: 'Als Fake-Profil markieren',
                type: 'CheckboxSelector',
                hidden: !allowMark
              },
              {
                name: 'birthday',
                label: 'Geburtsdatum',
                type: 'BirthdaySelector',
                withRandomSelector: true
              },
              {
                name: 'physique',
                label: 'Figur',
                type: 'OptionSelector'
              },
              {
                name: 'i_search_for_activity',
                label: 'Ich suche',
                type: 'MultiOptionSelector',
                multiSelect: true
              },
              {
                name: 'interested_in_gender',
                label: 'Interessiert an',
                type: 'SexSelector',
                multiSelect: true
              },
              {
                name: 'height_in_cm',
                label: 'Größe (cm)',
                type: 'SliderSelector',
                max: 220,
                min: 140
              }
            ]"
          >
            <div slot="title">
              <h4>Fake-Profil bearbeiten</h4>
            </div>
          </resource>
        </div>
      </div>
    </section>
    <div v-if="isAdmin" class="row">
      <div class="col-7">
        <v-table
          :url="'/api/v1/friends/' + id"
          :filter="[
            {
              name: 'where',
              attributes: {
                customer_profile_id1: id,
                accepted: 1
              }
            },
            {
              name: 'with',
              value: ['receiver']
            }
          ]"
          :attributes="[
            {
              attribute: 'receiver',
              type: 'LinkFriendCell',
              name: 'Freund'
            },
            {
              attribute: 'receiver.is_fake',
              name: 'Fake',
              type: 'CheckMarkerCell'
            },
            {
              name: 'Aktion',
              type: 'DeleteFriendCell'
            }
          ]"
        ></v-table>
      </div>
      <div class="col-5">
        <div class="row">
          <div class="col-12">
            <v-table
              :url="'/api/v1/friends/' + id"
              :filter="[
                {
                  name: 'where',
                  attributes: {
                    customer_profile_id1: id,
                    accepted: null
                  }
                },
                {
                  name: 'with',
                  value: ['receiver']
                }
              ]"
              :attributes="[
                {
                  attribute: 'receiver',
                  type: 'LinkFriendCell',
                  name: 'Freund'
                },
                {
                  attribute: 'receiver.is_fake',
                  name: 'Fake',
                  type: 'CheckMarkerCell'
                },
                {
                  name: 'Aktion',
                  type: 'DeleteFriendCell'
                }
              ]"
            >
              <div slot="title">Offene gesendet</div>
            </v-table>
            <v-table
              :url="'/api/v1/friends/' + id"
              :filter="[
                {
                  name: 'where',
                  attributes: {
                    customer_profile_id2: id,
                    accepted: null
                  }
                },
                {
                  name: 'with',
                  value: ['sender']
                }
              ]"
              :attributes="[
                {
                  attribute: 'sender',
                  type: 'LinkFriendCell',
                  name: 'Freund'
                },
                {
                  attribute: 'sender.is_fake',
                  name: 'Fake',
                  type: 'CheckMarkerCell'
                },
                {
                  name: 'Aktion',
                  type: 'DeleteFriendCell'
                }
              ]"
            >
              <div slot="title">Offene eingehend</div>
            </v-table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isAdmin" class="row">
      <div class="col-12">
        <v-table
          url="/api/v1/message"
          :filter="[
            {
              name: 'with',
              value: ['sender', 'receiver']
            },
            {
              name: 'where',
              attributes: {
                sender_id: id
              }
            }
          ]"
          :attributes="[
            {
              attribute: 'id',
              name: 'ID'
            },
            {
              attribute: 'receiver',
              type: 'LinkFriendCell',
              name: 'Freund'
            },
            {
              type: 'DialogLink',
              name: 'Dialog'
            },
            {
              attribute: 'in',
              name: 'IN/OUT',
              type: 'InOrOutCell'
            },
            {
              attribute: 'body',
              name: 'Inhalt'
            },
            {
              attribute: 'type',
              name: 'Typ'
            },
            {
              attribute: 'created_at',
              name: 'Gesendet am',
              type: 'DateTimeCell'
            }
          ]"
        >
          <div slot="title">Nachrichten</div>
        </v-table>
      </div>
    </div>
    <div v-if="isAdmin" class="row">
      <div class="col-12">
        <customer-dialogs-table :customer="customer"></customer-dialogs-table>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <resource
          resource="customerProfile"
          notification="Die Notizen wurden gespeichert"
          :original="customer"
          :staticMode="isDeleted"
          :attributes="[
            {
              name: 'internal_notes',
              label: 'Intern (admin -> admin)',
              type: 'TextareaSelector',
              rows: 5
            },
            {
              name: 'admin_notes',
              label: 'Admininfo (admin -> moderator)',
              type: 'TextareaSelector',
              rows: 5
            }
          ]"
        >
          <div slot="title">
            <h4>Notizen</h4>
          </div>
        </resource>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultNullHtml } from "@/js/defaultNullHtml";
import CustomerDialogsTable from "@/components/tables/CustomerDialogsTable.vue";
import MediaEditCard from "src/components/UIComponents/Cards/MediaEditCard.vue";
import { getDateTimeHtml } from "@/js/date";

export default {
  components: {
    CustomerDialogsTable,
    MediaEditCard
  },
  data() {
    return {
      history: {},
      deleting: false
    };
  },
  async created() {
    await this.$store.dispatch("customerProfile/read", {
      filter: [
        {
          name: "where",
          attributes: {
            id: this.id
          }
        },
        {
          name: "with",
          value: "media"
        },
        {
          name: "last_message"
        }
      ],
      appends: ["ins", "outs", "user.verify_duration", "allow_mark"]
    });
    if (!this.customer.is_fake) {
      this.$router.push("/mitglieder/kartei/" + this.customer.id);
    }
    if (this.isAdmin) {
      this.$http
        .get(`/api/v1/customerProfile/${this.id}/history`)
        .then(({ data }) => {
          this.history = data;
        });
    }
  },
  computed: {
    created_at() {
      return getDateTimeHtml(this.customer.created_at);
    },
    id() {
      return Number(this.$route.params.id);
    },
    customer() {
      return this.$store.getters["customerProfile/find"](this.id);
    },
    customerLastMessage() {
      return this.customer.messages && this.customer.messages[0]
        ? this.customer.messages[0].computed_created_at
        : defaultNullHtml();
    },
    isDeleted() {
      return Boolean(this.customer.deleted_at);
    },
    calculatesZipcodeCache() {
      return this.$store.getters["backgroundTask/running"](
        "calculate-zipcode-cache"
      );
    },
    isAdmin() {
      return this.$store.getters["user/meHasRole"]("admin");
    },
    allowMark() {
      return Boolean(parseInt(this.customer.allow_mark));
    }
  },
  methods: {
    deleteProfile() {
      if (this.deleting) {
        return;
      }

      let confirmed = confirm("Sicher?");
      if (!confirmed) {
        return;
      }
      this.deleting = true;

      this.$http
        .delete(this.customer.delete_url)
        .then(() => {
          this.$notify({
            title: `${this.customer.name} wurde gelöscht`,
            type: "success"
          });

          this.$router.push("/fake/list");
        })
        .finally(() => {
          this.deleting = false;
        });
    }
  },
  watch: {
    id(newId, oldId) {
      this.$store.commit("customerProfile/delete", oldId);
      this.$store.dispatch("customerProfile/read", [
        {
          name: "where",
          attributes: {
            id: newId
          }
        }
      ]);
    }
  }
};
</script>
